/*
 *
 * Do not edit directly
 * Generated on Mon, 24 Jun 2024 16:18:26 GMT
 *
 */


const theme = {
  appearances: {
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs' ] },
      tokens: { animationPaddingBottomAfter: 8, animationPaddingTopAfter: 8 }
    }
  ],
  tokens: {
    animationBackgroundColorAfter: '#f4f4f7',
    animationBackgroundColorBefore: '#4b286d',
    animationColorAfter: '#414547',
    animationColorBefore: '#ffffff',
    animationDivColorAfter: '#2b8000',
    animationDivColorBefore: '#ffffff',
    animationHeightAfter: 24,
    animationHeightBefore: 0,
    animationPaddingBottomAfter: 16,
    animationPaddingBottomBefore: 0,
    animationPaddingTopAfter: 16,
    animationPaddingTopBefore: 0,
    chevronlinkFontName: 'HelveticaNow',
    chevronlinkFontWeight: '400',
    containerBackgroundColor: '#4b286d',
    containerGap: 10,
    padding: 16
  }
}
export default theme
